var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"text-none text-body-2",class:{ 'custom-disabled': _vm.disabled },attrs:{"elevation":"0","dark":"","color":_vm.is_accent ? 'primary' : 'accent_gray',"disabled":_vm.disabled}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }